import {initWebComponent} from "@/helpers/web-component-helper";
import {addLayerActive, addLayerActiveById, removeLayerActive} from "@/helpers/ol/ol-layer-active-helper";
import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper";
import {clickCheckbox} from "@/helpers/layer-menu-group-merged-helper.js";

export class LayerMenuGroupMergedComponent extends HTMLElement{
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const depth = this.getAttribute('data-depth')
        const type = this.getAttribute('data-type')
        const checked = this.getAttribute('data-checked')
        const icon = this.getAttribute('data-icon')
        const catalog = this.getAttribute('data-catalog')
        let label = this.getAttribute('data-label')
        const branch = window.branchMerged[key][depth]

        const id = branch.ID

        if(!label) {
            label = branch.label
        }

        if(!id) {
            return
        }

        let checkedValue = ''
        let hiddenClass = 'd-none'

        if(window.urlParamsObject.bookmarkpresentatieids) {
            if(window.urlParamsObject.bookmarkpresentatieids.split(',').find(presentationName => presentationName === depth)) {
                branch.Checked = 1
            } else {
                branch.Checked = 0
            }
        }

        if(parseInt(branch.Checked) === 1) {
            checkedValue = 'checked="checked"'
            hiddenClass = ''
        }

        if(window.urlParamsObject.aan) {
            if(window.urlParamsObject.aan.split(',').find(presentationName => presentationName === label)) {
                checkedValue = 'checked="checked"'
            } else {
                checkedValue = ''
            }
        }

        let filterForm = ''
        let mutationForm = ''
        let bookmarkPresentationID = branch.branch[0].ID

        if(branch.branch.length > 0) {
            bookmarkPresentationID = []
            branch.branch.map((branchItem) => {
                if(branchItem.branch) {
                    branchItem.branch.map((branchItemChild) => {
                        bookmarkPresentationID.push(branchItemChild.ID)
                    })
                } else {
                    bookmarkPresentationID.push(branchItem.ID)
                }
            })
            bookmarkPresentationID = bookmarkPresentationID.join(',')
        }

        branch.branch.map((childBranch) => {
            if(mutationForm === '' && childBranch.serviceType === 'WFS' && childBranch.mutation_forms.length > 0) {

                console.log(childBranch)

                const formLabel = childBranch.mutation_forms[0].form.Name

                mutationForm = `<layer-menu-button-mutation data-label="${formLabel}" data-branch-id="${childBranch.ID}"></layer-menu-button-mutation>`
            }

            if(filterForm === '' && childBranch.filter_forms && childBranch.filter_forms.length > 0) {
                filterForm = `<layer-menu-button-filter data-bookmark-presentation-id="${bookmarkPresentationID}"></layer-menu-button-filter>`
            }
        })

        if(checked === 'true') {
            checkedValue = 'checked="checked"'
            hiddenClass = ''
        }

        const template = document.createElement('template');
        let innerHTML = `
            <div class="card-body accordion-group-item">
                <div class="form-group">
                    <label class="custom-control custom-checkbox">
                        <input type="checkbox" value="` + id + `" data-label="` + label + `" class="custom-control-input checkbox-group-item" ` + checkedValue + `>
                        <span class="custom-control-label" title="${label}">` + label + `<div class="label-sk-wave"></div></span>
                        <div class="layer-menu-button mr-1">
                            <layer-menu-active-item-remove data-parent-id="${id}" data-id="${bookmarkPresentationID}"></layer-menu-active-item-remove>
                            <layer-menu-button-info data-label="${label}" class="${hiddenClass}" data-id="${bookmarkPresentationID}"></layer-menu-button-info>
                            <layer-menu-button-zoom-scale data-label="${label}" class="d-none" data-id="${bookmarkPresentationID}"></layer-menu-button-zoom-scale>
                            ${filterForm}
                            ${mutationForm}
                        </div>
                    </label>`
     innerHTML += `</div>
            </div>
        `;
        template.innerHTML = innerHTML

        initWebComponent(this, template)

        if(parseInt(branch.Checked) === 1) {
            clickCheckbox(this.querySelector('input'), label, catalog, depth, key)
            setTimeout(() => {
                document.querySelector('layer-menu-overview layer-menu-group-merged[data-depth="' + depth + '"]').querySelector('input').checked = true
                this.querySelector('input').checked = true
            }, 0)
        }

        this.addEventListener('click', (event) => {
            clickCheckbox(event.target, label, catalog, depth, key)
        })

        function clickCheckbox(element, component) {
            if(element.type === 'checkbox') {

                const mergedElement = document.querySelector('layer-menu-overview layer-menu-group-merged[data-label="' + label + '"]')


                const card =   mergedElement.closest('layer-menu-group').querySelector('.card')



                card.querySelectorAll('layer-menu-group-item input').forEach(input => {
                    const branchItem = getBranchItemByBookmarkPresentationID(input.value)
                    if(branchItem.parent && branchItem.parent.BoundingBoxType === undefined || (branchItem.checked === 1 || branchItem.defaultChecked === 1)) {


                        if (element.checked && !input.checked) {
                            input.click()

                            addLayerActiveById(branchItem.ID)
                        }

                        if (!element.checked && input.checked) {
                            input.click()

                            removeLayerActive(branchItem.ID)
                        }
                    }
                })

                if(catalog !== 'false') {

                    console.log('add')
                    console.log(element.checked)
                    console.log(label)

                    if(element.checked) {
                        if(!document.querySelector('layer-menu-active layer-menu-group-merged[data-label="' + label + '"]')) {

                            const branchItem = getBranchItemByBookmarkPresentationID(id)
                            console.log(branchItem)
                            if(branchItem && (branchItem.parent && !branchItem.parent.Merged) || (!branchItem.parent)) {
                                let selector = 'layer-active'
                                document.getElementById(selector).insertAdjacentHTML(
                                    "beforeend",
                                    `<layer-menu-group-merged data-checked="true" data-label="${label}" data-depth="${depth}" data-key="${key}" data-catalog="false"></layer-menu-group-merged>`
                                )
                            }


                        }
                    } else {
                        const item = document.querySelector('layer-menu-active layer-menu-group-merged[data-label="' + label + '"]')
                        if(item) {
                            item.remove()
                        }
                    }
                }
            }
        }
    }
}
